module.exports = __webpack_public_path__ + "img/KSC03764.e650e7b0.jpg";